import pages from '@/config/i18n.pages'

// Build a reverse lookup from Nuxt route name to i18n.pages key.
// Route names use '-' as separator (e.g. 'data-processing-agreement-suppliers-appendix-i')
// while pages keys use file paths with '/' (e.g. 'data-processing-agreement/suppliers/appendix-i').
const routeNameToPageKey = {}
Object.keys(pages).forEach(key => {
  // Nuxt generates route names by replacing '/' with '-' and removing trailing '/index'
  const routeName = key.replace(/\/index$/, '').replace(/\//g, '-')
  routeNameToPageKey[routeName] = key
})

export const setList = routeName => {
  const baseUrl = process.env.BASE_URL
  const alternate = []

  const name = routeName.split('___')[0]
  const page = routeNameToPageKey[name] || name

  const defaultUrl = pages[`${page}`]['en'] ? `en${pages[`${page}`]['en']}` : `pt-br${pages[`${page}`]['pt-br']}`
  const alternateDefault = {
    hid: 'alt-default',
    rel: 'alternate',
    href: `${baseUrl}/${defaultUrl}`,
    hreflang: 'x-default',
  }

  const pagesVariants = Object.keys(pages[`${page}`])

  pagesVariants.map(variant => {
    if (variant) {
      const hreflang = variant.length > 2 ? `${variant.split('-')[0]}-${variant.split('-')[1]?.toUpperCase()}` : variant

      if (!pages[page][variant]) {
        return
      }

      const alternateObj = {
        hid: `alt-${variant}`,
        rel: 'alternate',
        href: `${baseUrl}/${variant}${pages[page][variant]}`,
        hreflang,
      }

      alternate.push(alternateObj)
    }

    return true
  })

  alternate.push(alternateDefault)

  if (alternate.length <= 2) return []

  return alternate
}

export default {
  setList,
}
